import styled from 'styled-components';

const Container = styled.div`
  height: 42px;
  border-radius: 25px;
  box-sizing: border-box;
  border: solid 1px ${({ theme }) => theme.colors.french_gray_1};
  padding: ${({ theme }) => theme.spacing(2)};
  background-color: ${({ theme }) => theme.colors.white};
`;

export default Container;
